"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const AboutTheWcaIcon = createIcon({
  displayName: "AboutTheWcaIcon",
  viewBox: "0 0 45 41",
  path: (
    <>
      <path
        d="M0,41V0h22.5v9.11h22.5v31.89H0ZM4.5,36.44h13.5v-4.56H4.5v4.56ZM4.5,27.33h13.5v-4.56H4.5v4.56ZM4.5,18.22h13.5v-4.56H4.5v4.56ZM4.5,9.11h13.5v-4.56H4.5v4.56ZM22.5,36.44h18V13.67h-18v22.78ZM27,22.78v-4.56h9v4.56h-9ZM27,31.89v-4.56h9v4.56h-9Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default AboutTheWcaIcon;
